import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { SamplePlan } from './components/SamplePlan';
import { PageCarousel } from './components/PageCarousel';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// Review sections render only once data/testimonials.ts holds real buyer reviews.

export function App() {
  return <div className="min-h-screen w-full bg-cloud text-ink font-sans selection:bg-amber selection:text-ink" data-id="element-0" data-mp="3mkhmhu9cv461">
      <MetaPixel data-id="element-1" data-mp="3rdkisa5iorpx" />
      <main data-id="element-2" data-mp="3rd1all5o5hp3">
        <Hero data-id="element-3" data-mp="3recctgjguhe3" />
        <SocialProofBar data-id="element-4" data-mp="5yimri0b7dt" />
        <PainGrid data-id="element-5" data-mp="67znpl2q47d" />
        <ProductReveal data-id="element-6" data-mp="4n53zyrel9i" />
        <Tomes data-id="element-7" data-mp="56qjqnmbrsa" />
        <SamplePlan data-id="element-8" data-mp="7stfczkdj46" />
        <PageCarousel data-id="element-9" data-mp="2zld43f9knpe6" />
        <Bonuses data-id="element-10" data-mp="2zm4wkh7vh708" />
        <ValueStack data-id="element-11" data-mp="2zmo6bandcp36" />
        <Urgency data-id="element-12" data-mp="2zn6cp03qwjot" />
        <Pricing data-id="element-13" data-mp="33mowfsjtyoq2" />
        <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="white" data-id="element-14" data-mp="33m5bs42spm8c" />
        <Guarantee data-id="element-15" data-mp="38l8f9k34nke7" />
        <Faq data-id="element-16" data-mp="38l03xwmnkn54" />
        <Testimonials testimonials={moreTestimonials} title="Works alongside your curriculum" subtitle="Teachers use it to turn the skills they already teach into a full year of sessions." background="cream" data-id="element-17" data-mp="38k6wetfvdtlx" />
        <CostOfInaction data-id="element-18" data-mp="su43de928wdn" />
        <Close data-id="element-19" data-mp="stc8k5naf2of" />
      </main>
      <Footer data-id="element-20" data-mp="swqcvjfihlyi" />
    </div>;
}